import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import s from './RideFare.css';
import getAllRideFareQuery from './getAllRideFare.graphql';
import RideFareList from '../../../../components/SiteAdmin/RideFare/RideFareList';
import Loader from '../../../../components/Common/Loader/Loader';
import messages from '../../../../locale/messages';

class RideFare extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired
  };

  static defaultProps = {
    rideFareDetails: {
      loading: true
    }
  };

  render() {
    const { rideFareDetails, rideFareDetails: { loading } } = this.props;

    return (
      <Loader type={"page"} show={loading}>
        <div className={s.root}>
          <div className={s.container}>
            <div className={cx(s.heading, 'textAlignRightRTL')}>
              <FormattedMessage {...messages.manageRideFare} />
            </div>
            <div className={s.paddingRoutesSection}>
              {!loading && <RideFareList rideFareDetails={rideFareDetails} />}
            </div>
          </div>
        </div>
      </Loader>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getAllRideFareQuery, {
    name: 'rideFareDetails',
    options: {
      ssr: true,
      fetchPolicy: 'network-only',
      variables: {
        currentPage: 1,
        searchList: ''
      }
    }
  })
)(RideFare);
